export default "__VITE_PUBLIC_ASSET__88dde2cb__"